import { createUseStyles } from 'react-jss'

export const baseStyle = {
  flex: 1,
  display: 'flex',
  flexFlow: 'column wrap',
  alignItems: 'center',
  padding: '20px',
  marginBottom: '2rem',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#888',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  outline: 'none',
  transition: 'border .24s ease-in-out',
}

export const disabledStyle = {
  opacity: '.5',
}

export const acceptStyle = {
  borderColor: '#00e676',
}

export const rejectStyle = {
  borderColor: '#ff1744',
}

export const focusedStyle = {
  borderColor: '#2196f3',
}

export const useStyles = createUseStyles({
  wrapper: {
    position: 'relative',
  },

  select: {
    maxWidth: '20rem',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '.8rem',
  },

  selectLabel: {
    textTransform: 'uppercase',
    fontSize: '.8125rem',
    fontWeight: 'bold',
    marginRight: '.5rem',
  },

  selectElement: {
    flex: '1',
  },

  loadingIcon: {
    marginRight: '.5rem',
  },

  filetypes: {
    fontSize: '.8rem',
    textAlign: 'center',
  },

  dropMessage: {
    textAlign: 'center',
  },

  dropReject: {
    color: '#ff1744',
    textAlign: 'center',
  },
})

export default useStyles
